import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputToggleFn = /* @__PURE__ */ createRecipe('input-toggle', {
  "variant": "filled",
  "color": "neutral",
  "size": "m"
}, [
  {
    "variant": "filled",
    "color": "primary",
    "css": {
      "color": "neutral.foreground.1.onBrand.enabled",
      "backgroundColor": "primary.background.2.enabled",
      "_hover": {
        "backgroundColor": "primary.background.2.hovered"
      },
      "_active": {
        "backgroundColor": "primary.background.2.actived"
      },
      "_expanded": {
        "backgroundColor": "primary.background.2.hovered"
      }
    }
  },
  {
    "variant": "filled",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.1.onBrand.enabled",
      "backgroundColor": "neutral.background.6.enabled",
      "_hover": {
        "backgroundColor": "neutral.background.6.hovered"
      },
      "_active": {
        "backgroundColor": "neutral.background.6.actived"
      },
      "_expanded": {
        "backgroundColor": "neutral.background.6.hovered"
      }
    }
  },
  {
    "variant": "filled",
    "color": "danger",
    "css": {
      "color": "neutral.foreground.1.onBrand.enabled",
      "backgroundColor": "danger.background.1.enabled",
      "_hover": {
        "backgroundColor": "danger.background.1.hovered"
      },
      "_active": {
        "backgroundColor": "danger.background.1.actived"
      },
      "_expanded": {
        "backgroundColor": "danger.background.1.hovered"
      }
    }
  },
  {
    "variant": "outlined",
    "color": "primary",
    "css": {
      "color": "primary.foreground.2.enabled",
      "borderColor": "primary.stroke.3.enabled",
      "_hover": {
        "color": "primary.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "primary.stroke.3.hovered"
      },
      "_active": {
        "color": "primary.foreground.2.actived",
        "backgroundColor": "neutral.background.2.actived",
        "borderColor": "primary.stroke.3.actived"
      },
      "_expanded": {
        "color": "primary.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "primary.stroke.3.hovered"
      }
    }
  },
  {
    "variant": "outlined",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.2.enabled",
      "borderColor": "neutral.stroke.7.enabled",
      "_hover": {
        "color": "neutral.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "neutral.stroke.7.hovered"
      },
      "_active": {
        "color": "neutral.foreground.2.actived",
        "backgroundColor": "neutral.background.2.actived",
        "borderColor": "neutral.stroke.7.actived"
      },
      "_expanded": {
        "color": "neutral.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "neutral.stroke.7.hovered"
      }
    }
  },
  {
    "variant": "outlined",
    "color": "danger",
    "css": {
      "color": "danger.foreground.1.enabled",
      "borderColor": "danger.stroke.1.enabled",
      "_hover": {
        "color": "danger.foreground.1.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "danger.stroke.1.hovered"
      },
      "_active": {
        "color": "danger.foreground.1.actived",
        "backgroundColor": "neutral.background.2.actived",
        "borderColor": "danger.stroke.1.actived"
      },
      "_expanded": {
        "color": "danger.foreground.1.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "danger.stroke.1.hovered"
      }
    }
  },
  {
    "variant": "ghost",
    "color": "primary",
    "css": {
      "color": "primary.foreground.2.enabled",
      "_hover": {
        "color": "primary.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      },
      "_active": {
        "color": "primary.foreground.2.actived",
        "backgroundColor": "neutral.background.2.actived"
      },
      "_expanded": {
        "color": "primary.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      }
    }
  },
  {
    "variant": "ghost",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.2.enabled",
      "_hover": {
        "color": "neutral.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      },
      "_active": {
        "color": "neutral.foreground.2.actived",
        "backgroundColor": "neutral.background.2.actived"
      },
      "_expanded": {
        "color": "neutral.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      }
    }
  },
  {
    "variant": "ghost",
    "color": "danger",
    "css": {
      "color": "danger.foreground.1.enabled",
      "_hover": {
        "color": "danger.foreground.1.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      },
      "_active": {
        "color": "danger.foreground.1.actived",
        "backgroundColor": "neutral.background.2.actived"
      },
      "_expanded": {
        "color": "danger.foreground.1.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      }
    }
  }
])

const inputToggleVariantMap = {
  "color": [
    "danger",
    "unstyled",
    "primary",
    "neutral"
  ],
  "variant": [
    "unstyled",
    "filled",
    "outlined",
    "ghost"
  ],
  "size": [
    "l",
    "m",
    "s"
  ],
  "width": [
    "block"
  ],
  "shape": [
    "rounded"
  ]
}

const inputToggleVariantKeys = Object.keys(inputToggleVariantMap)

export const inputToggle = /* @__PURE__ */ Object.assign(memo(inputToggleFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputToggle',
  __getCompoundVariantCss__: inputToggleFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputToggleVariantKeys,
  variantMap: inputToggleVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputToggleVariantKeys)
  },
  getVariantProps: inputToggleFn.getVariantProps,
})